<template>
    <div class="container-fluid bg-dark px-5 d-none d-lg-block">
        <div class="row gx-0 align-items-center" style="height: 45px;">
            <div class="col-lg-12 text-center text-lg-start mb-lg-0">
                <div class="d-flex flex-wrap">
                    <marquee><a href="javascript:void(0)" class="text-light me-4">Simfast Jateng (Sistem Informasi Manajemen Infrastruktur Terpadu Provinsi Jawa Tengah) <span class="pmisyellow">#Strategi Mensinergikan Fokus dan Arah Kebijakan Perencanaan Berbasis Data Spasial Terpadu di Jawa Tengah</span></a></marquee>
                </div>
            </div>
        </div>
    </div>
    <!-- Topbar End -->
    <div class="container-fluid position-relative p-0">
        <nav class="navbar navbar-expand-lg navbar-light bg-white px-4 px-lg-5 py-3 py-lg-0">
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                <span class="fa fa-bars"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarCollapse">
                <div class="navbar-nav ms-auto py-0">
                    <a href="/"
                        :class="[((route.name == 'Beranda' || route.name == 'Beranda2') ? 'nav-item nav-link active' : 'nav-item nav-link')]">
                        BERANDA
                    </a>
                    <a href="/DataProfil"
                        :class="[((route.name == 'DataProfil') ? 'nav-item nav-link active' : 'nav-item nav-link')]">
                        PROFIL INFRASTRUKTUR
                    </a>
                    <a :href="'/GIS/' + bytes"
                        :class="[((route.name == 'GIS') ? 'nav-item nav-link active' : 'nav-item nav-link')]">
                        PETA SIG IT
                    </a>
                    <a href="/Riwayat"
                        :class="[((route.name == 'Riwayat') ? 'nav-item nav-link active' : 'nav-item nav-link')]">
                        RIWAYAT PENANGANAN
                    </a>
                    <a href="/Usulan"
                        :class="[((route.name == 'Usulan') ? 'nav-item nav-link active' : 'nav-item nav-link')]">
                        USULAN RENCANA PENANGANAN
                    </a>
                    <a href="/BankDokumen"
                        :class="[((route.name == 'BankDokumen') ? 'nav-item nav-link active' : 'nav-item nav-link')]">
                        BANK DOKUMEN
                    </a>
                    <a href="/SDALH"
                        :class="[((route.name == 'SDALH') ? 'nav-item nav-link active' : 'nav-item nav-link')]">
                        PROFIL SDA LH
                    </a>
                    <a href="/ProfilKemiskinan"
                        :class="[((route.name == 'ProfilKemiskinan') ? 'nav-item nav-link active' : 'nav-item nav-link')]">
                        DATA KEMISKINAN
                    </a>
                    <a href="/KontakKami"
                        :class="[((route.name == 'KontakKami') ? 'nav-item nav-link active' : 'nav-item nav-link')]">
                        STATISTIK
                    </a>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';

export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        swal
    },
    data() {
        return {
            tabaktif: encodeURIComponent(CryptoJS.AES.encrypt('', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),
            tahun: new Date().getFullYear(),
            bahasa: localStorage.getItem("bahasasistem"),
            bytes: encodeURIComponent(CryptoJS.AES.encrypt('Kosong', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),
        };
    },
    methods: {
        gantibahasa(bahasanya) {
            localStorage.setItem("bahasasistem", bahasanya);
            location.reload();
        },
    },
    mounted() {
        localStorage.removeItem('bahasasistem');
    },
}
</script>

<style></style>